import { render, staticRenderFns } from "./orderCommLogList.vue?vue&type=template&id=44630a18&scoped=true&"
import script from "./orderCommLogList.vue?vue&type=script&lang=js&"
export * from "./orderCommLogList.vue?vue&type=script&lang=js&"
import style0 from "./orderCommLogList.vue?vue&type=style&index=0&id=44630a18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44630a18",
  null
  
)

export default component.exports